import { date } from '@mooveguru/js-utilities';
import { Link } from 'react-router-dom';
import { translate } from '../App/Internationalization';
import CopyToClipboard from './Links/CopyToClipboard';
import images from '../config/local/images';
import LinkButton from './LinkButton';
import paths from '../config/local/paths';
import ProfileImage from './ProfileImage';
import React from 'react';
import SocialMediaLinks from './SocialMediaLinks';

export default class BlogPostExcerptCard extends React.Component {
	/**
	 * @private
	 * @param {string=} base
	 * @returns {string}
	 */
	getPath(base) {
		const pathPartList = [base ?? ''];

		pathPartList.push(this.props.agentSlug ?? '', paths.blog);

		pathPartList.push(this.props.slug);

		const path = pathPartList
			// Strips `/` chars from start and end of string
			.map((part) => part && part.replace(/^\/|\/$/g, ''))
			.filter(Boolean)
			.join('/');

		return (base ? '' : '/') + path;
	}

	/**
	 * @private
	 * @param {boolean} forSocialMedia
	 * @returns {string}
	 */
	getExternalUrl(forSocialMedia) {
		/**
		 * @type {string | URL}
		 */
		let url;
		try {
			url = new URL(
				`https://blog.homekeepr.io/${this.props.slug}${
					forSocialMedia
						? ''
						: `?tenant=${window.location.hostname}&sharedby=${this.props.agentSlug}`
				}`
			);
		} catch {
			url = new URL(`${window.location.origin}/blog`);
		}

		return url.toString();
	}

	getSharableButtons() {
		const shareableUrl = this.getExternalUrl(false);
		const socialShareUrl = this.getExternalUrl(true);

		if (!this.props.gated) {
			return (
				<React.Fragment>
					<span className="share-label">
						{translate('homeowner.pages.dashboard.blog.share')}
					</span>

					<section className="button-group">
						<SocialMediaLinks
							authorImage={this.props.headshotUrl}
							authorName={this.props.authorName}
							blogPreview={true}
							date={this.props.date}
							imageUrl={this.props.imageUrl}
							title={this.props.title}
							url={socialShareUrl}
						/>

						<CopyToClipboard url={shareableUrl} />
					</section>
				</React.Fragment>
			);
		}
		return (
			<LinkButton
				className="button button-icon"
				icon={images.icons.subscription}
				iconClass="icon"
				to={paths.app.agent.subscription.root}
			>
				{translate('homeowner.pages.dashboard.blog.upgrade')}
			</LinkButton>
		);
	}

	/**
	 * @returns {JSX.Element}
	 */
	/* eslint-disable max-lines-per-function -- long but not complex*/
	render() {
		const blogPath = this.getPath();

		return (
			<section
				className={`card card-blog card-border-light ${
					this.props.gated ? 'pointer-events-none' : ''
				}`}
			>
				<header className="card-header">
					<section className="card-header-text">
						<h2
							className="card-title"
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: this.props.title,
							}}
						/>
					</section>
				</header>

				<Link
					data-activity-click="blog_article"
					data-activity-id={this.props.title}
					to={{
						pathname: blogPath,
						state: {
							referrer: `${location.pathname}${location.search}${location.hash}`,
						},
					}}
				>
					<img
						alt={this.props.title}
						className="card-image"
						src={this.props.imageUrl}
					/>
				</Link>

				<section className="card-attribution card-body">
					<ProfileImage headshotUrl={this.props.headshotUrl}>
						<figcaption className="name">
							{translate('homeowner.pages.dashboard.blog.by')}{' '}
							{this.props.authorName.toUpperCase()}
						</figcaption>
					</ProfileImage>

					<div className="card-date">
						{date.convertDateToDateString(this.props.date)}
					</div>
				</section>

				<footer className="card-footer">
					<section
						className={`justified-row ${
							this.props.gated ? 'justify-center' : ''
						}`}
					>
						{this.getSharableButtons()}
					</section>
				</footer>
			</section>
		);
	}
	/* eslint-enable max-lines-per-function */
}

BlogPostExcerptCard.defaultProps = {
	isAgentDashboard: false,
};
